import { CashflowColumn } from './components/CashflowTable';
import { amountCell, frequencyAmountCell } from './components/cashflowCells';
import { Expenditure } from './hooks/useExpenditures';
import { Income } from './hooks/useIncomes';
import { LifeEvent } from './hooks/useLifeEvents';
import { labelForIncomeType } from './incomeTypes';
import { dateOrNotRecorded } from './notRecorded';
import { Period } from './utils';
import { TenantCurrency } from 'src/common/currency';

export function incomeColumns<T extends Income>(
  period: Period,
  currency: TenantCurrency,
): CashflowColumn<T>[] {
  return [
    {
      key: 'incomeType',
      header: 'Type',
      renderValue: (_value, item) => labelForIncomeType(item.incomeType),
    },
    { key: 'description', header: 'Source' },
    { key: 'frequency', header: 'Frequency' },
    {
      key: 'amountPreTax',
      header: 'Before tax',
      renderValue: (_value, item) =>
        frequencyAmountCell(period, item.amountPreTax, item.frequency, currency, {
          positive: true,
        }),
    },
    {
      key: 'amountPostTax',
      header: 'After tax',
      renderValue: (_value, item) =>
        frequencyAmountCell(period, item.amountPostTax, item.frequency, currency, {
          positive: true,
        }),
    },
  ];
}

export function expenditureColumns<T extends Expenditure>(
  period: Period,
  currency: TenantCurrency,
): CashflowColumn<T>[] {
  return [
    { key: 'category', header: 'Category' },
    { key: 'frequency', header: 'Frequency' },
    {
      key: 'amount',
      header: `Spend (${period})`,
      renderValue: (_value, item) =>
        frequencyAmountCell(period, item.amount, item.frequency, currency),
    },
  ];
}

export function lifeEventColumns<T extends LifeEvent>(
  currency: TenantCurrency,
): CashflowColumn<T>[] {
  return [
    { key: 'description', header: 'Description' },
    {
      key: 'eventDate',
      header: 'Date',
      renderValue: (_value, item) => dateOrNotRecorded(item.eventDate),
    },
    { key: 'details', header: 'Details' },
    {
      key: 'cost',
      header: 'Amount',
      renderValue: (_value, item) => amountCell(item.cost, currency),
    },
  ];
}

export function withMemberColumn<T extends { memberName: string }>(
  columns: CashflowColumn<T>[],
): CashflowColumn<T>[] {
  return [{ key: 'memberName', header: 'Member' }, ...columns];
}
